import { render } from "./SettingsEvent.vue?vue&type=template&id=f3058572"
import script from "./SettingsEvent.vue?vue&type=script&lang=js"
export * from "./SettingsEvent.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__